import React from "react"
import { Badge } from "react-bootstrap"
import { Link } from "react-router-dom"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import moment from "moment/moment"
import { FormattedMessage, FormattedRelative } from "react-intl"
import GlobalHelper from "../../GlobalHelper"
import { useQuery } from "react-query"
import AccountLimitService from "../../../state/account-limit/AccountLimitService"
import { ACCOUNT_STATUS, AccountStatus } from "../../../utils/account"

const AccountStatusBadgeComponent = () => {
    const {data, isLoading} = useQuery("account-limit", () => AccountLimitService.Get())

    const status = AppContext.getAccount().attributes.status as AccountStatus
    const today = moment()
    const expirationDate = moment(AppContext.getAccount().attributes.expiredAt)
    const accountHasExpired = today > expirationDate

    const accountGracePeriodInDays = AppContext.getAccount().attributes.gracePeriodInDays
    const expirationDatePlusGracePeriod = moment(expirationDate).add(accountGracePeriodInDays, "days")
    const gracePeriodReached = today > expirationDatePlusGracePeriod

    switch (status) {
    case ACCOUNT_STATUS.DEMO:
        return <Badge variant={"warning"}>
            <FormattedMessage
                id="main.menu.status.demo"
                defaultMessage="Demo account"
            />
        </Badge>
    case ACCOUNT_STATUS.TRIAL:
        return <Link to={"/my-account"}
            className="btn btn-sm btn-outline-danger mb-0 text-align-center status-account-demo rounded py-1">
            {!accountHasExpired ? <FormattedMessage
                id="main.menu.status.trial"
                defaultMessage="Trial ending {relativeDate}"
                values={{
                    relativeDate: <FormattedRelative value={expirationDate.toDate()}/>
                }}
            /> : <FormattedMessage
                id="main.menu.status.trial_select_plan"
                defaultMessage="Trial expired {relativeDate}.{lineBreak}Select your plan."
                values={{
                    lineBreak: <br></br>,
                    relativeDate: <FormattedRelative value={expirationDate.toDate()}/>
                }}
            />
            }
        </Link>
    case ACCOUNT_STATUS.EXPIRED:
        return <Link to={"/my-account"}
            className="btn btn-sm btn-outline-danger mb-0 text-align-center status-account-demo rounded py-1">
            {
                accountHasExpired ?
                    (!gracePeriodReached ?
                        <FormattedMessage
                            id="main.menu.status.expired_will_be_disabled"
                            defaultMessage="Your account expired {expirationDate}.
                            It will be disabled {expirationDatePlusGracePeriod}."
                            values={{
                                expirationDate: <FormattedRelative value={expirationDate.toDate()}/>,
                                expirationDatePlusGracePeriod: <FormattedRelative
                                    value={expirationDatePlusGracePeriod.toDate()}/>
                            }}
                        /> : <FormattedMessage
                            id="main.menu.status.expired_renew"
                            defaultMessage="Your account has been disabled. Renew your subscription."
                        />) :
                    <FormattedMessage
                        id="main.menu.status.expired"
                        defaultMessage="Subscription expiring {relativeDate}"
                        values={{
                            relativeDate: <FormattedRelative
                                value={new Date(AppContext.getAccount().attributes.expiredAt)}/>
                        }}
                    />
            }
        </Link>
    case ACCOUNT_STATUS.ACTIVE:
        return !isLoading && data && GlobalHelper.isAccountLimitExceeded(data.getDto()) ?
            <Link to={"/my-account?utm_source=restricted"}
                className="btn btn-sm btn-outline-danger mb-0 text-align-center status-account-demo rounded py-1">
                <FormattedMessage
                    id="main.menu.status.documents_exceeded"
                    defaultMessage="Number of documents exceeded."
                />
            </Link> : <></>
    }
    return <></>
}

export default AccountStatusBadgeComponent


// WEBPACK FOOTER //
// ./src/common/layout/components/AccountStatusBadgeComponent.tsx